<script setup lang="ts">
defineProps<{ attrname: string; isExactMatch: boolean; value: string }>()

const { t, te, locale } = useI18n()
// te does not support fallbacks, so we need to do it manually
// https://github.com/intlify/vue-i18n/issues/1765
const localeFixed = computed(() => (locale.value.startsWith("en") ? "en" : "fr-FR"))
</script>

<template>
  <UBadge
    v-tippy="value"
    :color="isExactMatch ? 'rnxblue' : 'gray'"
    :class="isExactMatch ? 'opacity-50' : 'opacity-30'"
    class="truncate"
    variant="outline"
    :ui="{ rounded: 'rounded-full' }"
    size="xs"
  >
    <span v-if="te(`attr.${attrname}`, localeFixed)" class="truncate">
      {{ t(`attr.${attrname}`) }}
    </span>
    <span v-else class="truncate">{{ attrname.replace(/[.,_]/g, " ") }}</span>
  </UBadge>
</template>

<i18n scoped lang="yaml">
en:
  attr:
    deliverypoints:
      prm: "prm"
      card: "card"
    contract:
      purchase_order: "contract number"
      type: "contract type"
    invoice_submit_channel: "submit channel"
    current_status: "status"
    assetowner:
      name: "spv name"
    counterpart:
      name: "counterpart name"
    managed_party:
      name: "managed party name"
    registration_office: "office"
    clause_types: "clause type"

fr-FR:
  attr:
    name: "nom"
    external_id: "id externe"
    deliverypoints:
      prm: "prm"
      card: "card"
    start: "date début"
    publication_date: "date pub."
    publication_id: "id pub."
    site:
      name: "nom site"
    contract:
      type: "type contrat"
      purchase_order: "n° contrat"
    external_name: "nom externe"
    purchase_order: "n° contrat"
    contract_type: "type contrat"
    order_number: "numéro de commande"
    market_number: "numéro marché"
    invoice_submit_channel: "canal d'envoi"
    current_status: "statut"
    clause_types: "type clause"
    assetowner:
      name: "nom spv"
    holding:
      name: "nom holding"
    counterpart:
      name: "nom contrepartie"
    managed_party:
      name: "nom partie gérée"
    registration_office: "siège"
</i18n>
